export const DISCOUNT_LANGUAGE_OFFER = {
  FIRST_LANGUAGE_FREE: "FIRST_LANGUAGE_FREE",
  FIRST_LANGUAGE_DISCOUNT: "FIRST_LANGUAGE_DISCOUNT"
}